import { render, staticRenderFns } from "./HmiPrincipal.vue?vue&type=template&id=52591a24&lang=true"
import script from "./HmiPrincipal.vue?vue&type=script&lang=js"
export * from "./HmiPrincipal.vue?vue&type=script&lang=js"
import style0 from "./HmiPrincipal.vue?vue&type=style&index=0&id=52591a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports